import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';
import { BaseModel } from '@shared/base/Base.Model';
import { AuthTypeEnum } from '@shared/enum/AuthType.Enum';


export class PreAuthResult extends BaseModel implements IRestModel {
    public result: Array<AuthTypeEnum> = null;

    public readonly isIRestModel = true;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'EM-PreAuthResult');
    }

    public toRestApiModel() {
        throw new Error('Method not implemented.');
    }
}
